import {
  CATEGORIES,
  INTEGRATIONS,
} from '@/mockData/integrationsData';

/**
 * Returns the integration catalog (categories + integrations).
 * This is static data used by both demo and prod modes.
 * Connection status is layered on top by useIntegrationConnections in prod.
 */
export function useIntegrationsData() {
  return { categories: CATEGORIES, integrations: INTEGRATIONS };
}
